



















import {Component, Vue} from "vue-property-decorator";

@Component({})
export default class Debug extends Vue {
    protected envs!: Array<{ key: string, value: string }>;

    public created() {
        this.envs = [];
        Object.keys(process.env).forEach((k) => {
            this.envs.push({
                key: k,
                value: process.env[k],
            });
        });
    }
}
